export function isDataURL(url) {
  return url && url.slice(0, 5) === "data:";
}

export function dataURLToBlob(dataURL) {
  const isBase64 = dataURL.split(",")[0].split(";")[1] === "base64";
  let byteString;

  if (isBase64) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURLs - see SO answer #6850276 for code that does this
    byteString = atob(dataURL.split(",")[1]);
  } else {
    byteString = dataURL.split(",")[1];
  } // separate out the mime component

  const mimeString = dataURL
    .split(",")[0]
    .split(":")[1]
    .split(";")[0]; // write the bytes of the string to an ArrayBuffer

  const ab = new ArrayBuffer(byteString.length); // create a view into the buffer

  const ia = new Uint8Array(ab); // set the bytes of the buffer to the correct values

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  } // write the ArrayBuffer to a blob, and you're done

  const blob = new Blob([ab], {
    type: mimeString
  });
  return blob;
}
